#
#  The (long term game) lobby filter
#
class window.Lobby
    ajaxLoader: '<i class="fa fa-spinner fa-pulse loader"></i>'
    ajaxSuccess: '<i class="fa fa-check success"></i>'
    ajaxError: '<i class="fa fa-times error"></i>'

    constructor: (@live, @listview, @games, @playerRowMe, @userRating) ->
        self = this

        # Refresh button click
        $('.refresh-lobby').click(() ->
            self.update(true)
            if self.live
                self.resetInterval()
            return false
        )

        # Code below is long term game room only
        if @live
            @resetInterval()
            return

        # Register the filter element clicks
        $('#lobby-filter input').click(() ->
            self.filterGames()
        )
        $('#lobby-filter select').change(() ->
            self.filterGames()
        )

        @filterGames()
        @initializeJoinGame()

    filterGames: () ->
        listtype = if @listview then 'row' else 'box'

        # Get the filter settings
        rankingModes = ([jq("ranking-mode-#{i}").is(':checked') for i in [0 .. 2]][0])
        gametypes = ([jq("gametype-#{i}").is(':checked') for i in [0 .. 7]][0])
        cards = ([jq("cards-#{i}").is(':checked') for i in [0 .. 4]][0])
        turnOrder = ([jq("turn-order-#{i}").is(':checked') for i in [0 .. 2]][0])
        fog = parseInt(jq('fog-of-war').val())
        advancedCards = parseInt(jq('advanced-cards').val())
        balancedDice = parseInt(jq('balanced-dice').val())
        teams = parseInt(jq('team-games').val())
        password = parseInt(jq('password-protected').val())
        turnTime = parseInt(jq('turn-time').val())
        allowDuplicates = jq('duplicates').is(':checked')
        filterRatingLimits = jq('rating').is(':checked')

        # Filter the games
        visibleGames = 0
        previous = null
        for g in @games
            el = $("#lobby-#{listtype}-#{g.game_id}")
            if rankingModes[g.ranking_mode] and gametypes[g.game_type] and cards[g.cards] and
                    turnOrder[g.turn_order] and check(fog, g.fog_of_war) and check(advancedCards, g.cards_advanced) and
                    check(balancedDice, g.dice) and check(teams, if g.players_per_team > 1 then 1 else 0) and
                    check(password, if g.hasPassword then 1 else 0) and check(turnTime, g.turn_time) and
                    not isDuplicate(allowDuplicates, g, previous) and
                    ratingIsInRange(filterRatingLimits, g, @userRating)
                el.show()
                if not @listview
                    el.css('display', 'inline-block')
                visibleGames++
            else
                el.hide()
            previous = g

        # Update the caption
        hiddenGames = $('.lobby-row, .page-box').length - visibleGames
        filterText = if hiddenGames isnt 0 then " (#{@gameCountText(hiddenGames)} hidden by filter)" else ''
        $('.lobby-caption').html("Displaying #{@gameCountText(visibleGames)}#{filterText}.")

    gameCountText: (count) ->
        return "#{count} #{noun('game', 'games', count)}"

    initializeJoinGame: () ->
        @initializeColorCircleClicks()
        @initializeJoinGameSubmitClicks()

    initializeColorCircleClicks: () ->
        $('.color-select a').click(() ->
            colorID = $(this).data('color')
            gameID = $(this).data('gameId')
            prefix = "#join-game-color-select-#{gameID}"

            $("#{prefix} .radio[data-color=#{colorID}]").click()

            $("#{prefix} div").removeClass('selected')
            $(this).parent().addClass('selected')

            $("#{prefix} .join-game-submit").removeAttr('disabled')
            $("#{prefix} .join-game-submit").removeClass('disabled')

            return false
        )

    initializeJoinGameSubmitClicks: () ->
        self = this
        $('.join-game-submit').click(() ->
            $(this).prop('disabled', true)

            # Retrieve color and game id
            gameID = $(this).data('gameId')
            prefix = "#join-game-color-select-#{gameID}"
            color = $("#{prefix}.color-select .radio[name='color']:checked").val()
            playerRowMe = self.playerRowMe

            $("#{prefix} .join-game-status").html(self.ajaxLoader)

            data = {
                _token: csrftoken
                color: color
            }
            if ($("#{prefix} .join-pw"))
                data['password'] = $("#{prefix} .join-pw").val()

            $.ajax({
                url: "#{baseurl}/game/#{gameID}/play/join-game"
                method: 'POST'
                data: data
                success: (result) ->
                    if (result.success)
                        $("#{prefix} .join-game-status").html(self.ajaxSuccess)

                        # Update player list.
                        playerList = $("#gamelist-more-info-#{gameID} .player-list")
                        $("#lobby-row-#{gameID} .num-players").html("#{playerList.length + 1} / ")
                        playerList.append(playerRowMe)

                        # Remove the selected from the selected element.
                        $("#{prefix}.color-select .selected").removeClass('selected')
                        # Remove the password
                        noPassword = '<span>No password needed because you have joined before.</span>'
                        $("#{prefix} .join-pw").replaceWith(noPassword)
                    else
                        $("#{prefix} .join-game-status").html(self.ajaxError + ' ' + result.error)
                        $("#{prefix} .join-game-submit").prop('disabled', false)
                error: (jqXHR, textStatus, errorThrown) ->
                    $("#{prefix} .join-game-status").html(self.ajaxError + ' ' + errorThrown)
                    $("#{prefix} .join-game-submit").prop('disabled', false)
            })

            return false
        )

    update: (force = false) =>
        if not force and not activity.isActive
            return

        $('.lobby-ajax-errors').html('')

        # Make the ajax call
        data = {
            _token: csrftoken
            live: @live
            listview: @listview
        }

        $.ajax({
            url: "#{baseurl}/lobby/update"
            method: 'POST'
            data: data
            success: (result) =>
                if (result.success)
                    @replaceGames(result.games, result.pendingGamesHtml, result.activeGamesHtml)
                else
                    lobbyRefreshError('Refresh failed')
            error: (jqXHR, textStatus, errorThrown) ->
                lobbyRefreshError(jqXHR)
        })

    replaceGames: (games, pendingGamesHtml, activeGamesHtml) ->
        @games = games

        prefix = if @listview then '.lobby-list tbody' else '.box-wrapper'
        postfix = if @listview then '> tr' else '> div'
        gameBox = if @listview then 'lobby-row' else 'page-box'

        # Add game rows/boxes to the dom
        $("#{prefix} #{postfix}").not('.lobby-no-games-found').remove()
        $(".pending #{prefix}").append(pendingGamesHtml)
        $(".active #{prefix}").append(activeGamesHtml)

        pendingCount = $(".pending #{prefix} ." + gameBox).length
        $(".pending .lobby-caption").html("Displaying #{pendingCount} #{noun('game', 'games', pendingCount)}.")

        activeCount = $(".active #{prefix} ." + gameBox).length
        $(".active .lobby-caption").html("Displaying #{activeCount} #{noun('game', 'games', activeCount)}.")

        if pendingCount is 0
            $(".pending .lobby-no-games-found").show()
        else
            $(".pending .lobby-no-games-found").hide()

        if activeCount is 0
            $(".active .lobby-no-games-found").show()
        else
            $(".active .lobby-no-games-found").hide()

        # Make sure that the rows/boxes work
        initializeShowHideLinks(prefix)
        if not @live
            @filterGames()
            @initializeJoinGame()

    resetInterval: () ->
        clearInterval(@updateLoop)
        @updateLoop = setInterval(@update, 30000)

#
# Some small (private) helper functions
#
jq = (name) ->
    return $("#lobby-filter [name=\"#{name}\"]")

check = (setting, value) ->
    return setting is -1 or setting is value

isDuplicate = (allowDuplicates, a, b) ->
    if allowDuplicates or b is null
        return false
    result = a.creator_id is b.creator_id and a.num_players is b.num_players and a.game_type is b.game_type and
        a.cards is b.cards and a.cards_cap is b.cards_cap and a.fog_of_war is b.fog_of_war and
        a.fortification is b.fortification and a.turn_order is b.turn_order and a.cards_advanced is b.cards_advanced and
        a.dice is b.dice and a.players_per_team is b.players_per_team and a.min_rating is b.min_rating and
        a.max_rating is b.max_rating and a.pointless is b.pointless and a.map_id is b.map_id and
        a.ranking_mode is b.ranking_mode
    return result

ratingIsInRange = (filterRatingLimits, game, userRating) ->
    if not filterRatingLimits or userRating is -1
        return true
    allowed = true
    if game.min_rating isnt null
        allowed and= game.min_rating <= userRating
    if game.max_rating isnt null
        allowed and= userRating <= game.max_rating
    return allowed

lobbyRefreshError = (error) ->
    $('.lobby-ajax-errors').append("<div class='error'>#{JSON.stringify(error, null, 4)}</div>")
